import type { Move } from '@mn/shared';

// ── Move pool: ~30 moves across all 8 elements + signature apex moves. ──
// Convention: power 0 = status/utility; accuracy is 0..1; pp is uses per battle.
// Signature/apex moves are high power / lower pp / sometimes lower accuracy.

export const MOVES: Move[] = [
  // ── Universal / beast ──
  { id: 'mv_tackle', name: 'Tackle', element: 'beast', power: 40, accuracy: 1.0, pp: 35 },
  { id: 'mv_gnash', name: 'Gnash', element: 'beast', power: 55, accuracy: 0.95, pp: 25 },
  { id: 'mv_rend', name: 'Rend', element: 'beast', power: 70, accuracy: 0.9, pp: 15 },
  { id: 'mv_savage_maul', name: 'Savage Maul', element: 'beast', power: 95, accuracy: 0.85, pp: 8 },
  { id: 'mv_intimidate', name: 'Intimidate', element: 'beast', power: 0, accuracy: 1.0, pp: 20 },

  // ── Flame ──
  { id: 'mv_ember', name: 'Ember', element: 'flame', power: 45, accuracy: 1.0, pp: 25 },
  { id: 'mv_cinder_lash', name: 'Cinder Lash', element: 'flame', power: 65, accuracy: 0.95, pp: 15 },
  { id: 'mv_pyre_burst', name: 'Pyre Burst', element: 'flame', power: 85, accuracy: 0.85, pp: 10 },
  { id: 'mv_magma_core', name: 'Magma Core', element: 'flame', power: 120, accuracy: 0.75, pp: 5 }, // apex

  // ── Tide ──
  { id: 'mv_splash_jet', name: 'Splash Jet', element: 'tide', power: 45, accuracy: 1.0, pp: 25 },
  { id: 'mv_brine_slash', name: 'Brine Slash', element: 'tide', power: 65, accuracy: 0.95, pp: 15 },
  { id: 'mv_tidal_crush', name: 'Tidal Crush', element: 'tide', power: 90, accuracy: 0.8, pp: 8 },
  { id: 'mv_abyssal_maw', name: 'Abyssal Maw', element: 'tide', power: 120, accuracy: 0.75, pp: 5 }, // apex

  // ── Verdant ──
  { id: 'mv_vine_whip', name: 'Vine Whip', element: 'verdant', power: 45, accuracy: 1.0, pp: 25 },
  { id: 'mv_thorn_volley', name: 'Thorn Volley', element: 'verdant', power: 65, accuracy: 0.9, pp: 15 },
  { id: 'mv_bloom_burst', name: 'Bloom Burst', element: 'verdant', power: 85, accuracy: 0.85, pp: 10 },
  { id: 'mv_worldroot', name: 'Worldroot', element: 'verdant', power: 115, accuracy: 0.8, pp: 5 }, // apex

  // ── Stone ──
  { id: 'mv_pebble_toss', name: 'Pebble Toss', element: 'stone', power: 40, accuracy: 1.0, pp: 30 },
  { id: 'mv_rock_slam', name: 'Rock Slam', element: 'stone', power: 70, accuracy: 0.9, pp: 15 },
  { id: 'mv_quake_stomp', name: 'Quake Stomp', element: 'stone', power: 95, accuracy: 0.8, pp: 8 },
  { id: 'mv_tectonic_judgment', name: 'Tectonic Judgment', element: 'stone', power: 125, accuracy: 0.7, pp: 5 }, // apex

  // ── Gale ──
  { id: 'mv_gust', name: 'Gust', element: 'gale', power: 45, accuracy: 1.0, pp: 25 },
  { id: 'mv_wing_cut', name: 'Wing Cut', element: 'gale', power: 65, accuracy: 0.95, pp: 15 },
  { id: 'mv_cyclone_dive', name: 'Cyclone Dive', element: 'gale', power: 90, accuracy: 0.85, pp: 8 },
  { id: 'mv_storm_sovereign', name: 'Storm Sovereign', element: 'gale', power: 120, accuracy: 0.8, pp: 5 }, // apex

  // ── Venom ──
  { id: 'mv_sting', name: 'Sting', element: 'venom', power: 40, accuracy: 1.0, pp: 30 },
  { id: 'mv_venom_spit', name: 'Venom Spit', element: 'venom', power: 60, accuracy: 0.95, pp: 20 },
  { id: 'mv_toxic_lash', name: 'Toxic Lash', element: 'venom', power: 85, accuracy: 0.85, pp: 10 },
  { id: 'mv_plague_bloom', name: 'Plague Bloom', element: 'venom', power: 115, accuracy: 0.75, pp: 5 }, // apex

  // ── Frost ──
  { id: 'mv_frost_nip', name: 'Frost Nip', element: 'frost', power: 45, accuracy: 1.0, pp: 25 },
  { id: 'mv_ice_shard', name: 'Ice Shard', element: 'frost', power: 65, accuracy: 0.95, pp: 15 },
  { id: 'mv_glacier_slam', name: 'Glacier Slam', element: 'frost', power: 90, accuracy: 0.8, pp: 8 },
  { id: 'mv_absolute_zero', name: 'Absolute Zero', element: 'frost', power: 125, accuracy: 0.7, pp: 5 }, // apex
];

export const MOVES_BY_ID: Record<string, Move> = Object.fromEntries(
  MOVES.map((m) => [m.id, m]),
);
